import { Injectable } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { PrivacyModalFlow } from "src/app/pages/privacy/privacyActions.service";
import { MetadataSource } from "src/app/common/models/privacy/Identity.model";

export interface IErrorText {
    translationId: string;
    props: {}
}

@Injectable()
export class OnBoardingService {
    constructor() { }

    //in functie de codul de eroare se afiseaza alt mesaj
    getErrorMessageByCode(err?) {
        if (err?.code) {
            switch (err.code) {
                case 32701: {
                    return {translationId: 'privacy.errors.database.err', props: null};
                }
                case 104: {
                    return {translationId: 'privacy.errors.invalid.params', props: null};
                }
                case 40011: {
                    return {translationId: 'privacy.errors.identity.exists', props: null};
                }
                case 40012: {
                    return {translationId: 'privacy.errors.no.identity', props: null};
                }
                case 40021: { //if the info you're trying to send a code to doesn't exist
                    return {translationId: 'privacy.errors.info.not.found', props: null};
                }
                case 40022: {
                    return {translationId: 'privacy.errors.info.exists', props: null};
                }
                case 40023: { //if the value parameter is invalid
                    return {translationId: 'privacy.errors.info.invalid', props: null};
                }
                case 40031: { //if you're trying to send a code to an already validated info
                    return {translationId: 'privacy.errors.info.validated', props: null};
                }
                case 40032: { //if the code couldn't be sent
                    return {translationId: 'privacy.errors.send.code.err', props: null};
                }
                case 40033: {
                    return {translationId: 'privacy.validations.validation.code.invalid', props: null};
                }
                case 40034: {
                    return {translationId: 'privacy.validations.validation.code.expired', props: null};
                }
                case 40035: {
                    if (err.data && err.data.wait_time) {
                        return {translationId: 'privacy.errors.validation.abuse.seconds', props: { seconds: err.data.wait_time }};
                    } else {
                        return {translationId: 'privacy.errors.validation.abuse', props: null};
                    }
                }
                default: {
                    return {translationId: 'activity.error.msg', props: null};
                }
            }
        }
        else {
            return {translationId: 'activity.error.msg', props: null};
        }
    }

    markFormAsTouched(form: UntypedFormGroup) { //pt design
        for (const key of Object.keys(form.controls)) {
            form.controls[key].markAsTouched();
        }
    }

    nextInput(event) { //pt design
        let parentForm = event.target.form;
        const getKey = (obj, val) => Object.keys(obj).find(key => obj[key] === val);
        const targetedElementIndex = parseInt(getKey(parentForm.elements, event.target));

        if (targetedElementIndex + 1 < parentForm.elements.length) {
            parentForm.elements[targetedElementIndex + 1].focus();
        }
    }

    setSource(flowType, metadata, setOnboardingUndefined: boolean = true) {
        if (flowType === PrivacyModalFlow.ONBOARDING) {
            return setOnboardingUndefined ? undefined : MetadataSource.ONBOARDING;
        } else if (flowType !== PrivacyModalFlow.ONBOARDING && metadata) {
            return MetadataSource.CONFIRMED; //confirmare din footprint
        } else if (flowType !== PrivacyModalFlow.ONBOARDING && !metadata) {
            return MetadataSource.ADDED; //adaugare din identity monitor
        }
    }
}